import React from "react"

import { useConfigContext } from "@app/providers/config"
import ProductMain from "@app/components/Product/ProductMain"
import ProductGiftcard from "@app/components/Product/ProductGiftcard"

import type { PageProps } from "@root/types/global"
import type { Props } from "@app/templates/product"

type ProductProps = PageProps<Props>

const Product: React.FC<ProductProps> = ({ product, ...rest }) => {
  const {
    settings: { product: productConfig },
  } = useConfigContext()
  const isGiftCard = product?.shopify?.handle === productConfig.giftcardHandle

  return isGiftCard ? <ProductGiftcard product={product} {...rest} /> : <ProductMain product={product} {...rest} />
}

export default Product
